import { render } from "./NdptEN.vue?vue&type=template&id=0e6a6b5b"
import script from "./NdptEN.vue?vue&type=script&lang=js"
export * from "./NdptEN.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__